import Loadable from 'react-loadable';

const PromotionsAndRewardsHub = Loadable({
  loader: () =>
    import(/* webpackChunkName: "PromotionsAndRewardsHub" */ './PromotionsAndRewardsHub'),
  modules: ['./PromotionsAndRewardsHub'],
  loading: () => null
});

export default PromotionsAndRewardsHub;
